<template>
	<div class="">
		<b-button block v-b-toggle.members-sharing>
			<i class="fas fa-users pr-1"></i>
			Click to Open
		</b-button>

		<b-collapse id="members-sharing" class="mt-2">
			<small class="text-muted pl-1">Members sharing their dashboard with you</small>
			<div v-if="members_sharing !== null && members_sharing.length > 0">
				<b-list-group
					v-for="item in members_sharing"
					:key="item.id"
					id="members_sharing"
					class="text-left mb-2"
				>
					<b-list-group-item>
						<div class="row">
							<div class="col-10">
								<b-button variant="link" class="gold" @click="showMemberData(item)">
									<i class="fas fa-search pr-1"></i> <small v-text="item.label"></small>
								</b-button>
							</div>

							<div class="col-2 text-right">
								<b-button
									variant="link"
									size="sm"
									class="mt-1"
									@click="removeMember(item, $event)"
								>
									<i class="far fa-trash-alt text-danger"></i>
								</b-button>
							</div>
						</div>
					</b-list-group-item>
				</b-list-group>
			</div>
			<div v-else>
				<small class="text-danger">No members are sharing dashboard's with you</small>
			</div>

			<hr />

			<b-form-group>
				<small class="">Select who to share your dashboard with</small>
				<v-select
					:options="share_members"
					:filterable="false"
					:multiple="true"
					@search="membersSearch"
					v-model="share_members_selected"
				>
					<template slot="no-options">
						<small>Search and select the members to share your dashboard with</small>
					</template>

					<template slot="option" slot-scope="option">
						<div class="d-center">
							{{ option.label }}
						</div>
					</template>

					<template slot="selected-option" slot-scope="option">
						<div class="selected d-center">
							{{ option.label }}
						</div>
					</template>
				</v-select>

				<div class="text-right">
					<b-button
						variant="primary"
						size="sm"
						class=""
						@click="updateSharedMembers()"
						:disabled="updateDisabled"
					>
						Update
					</b-button>
					<p v-if="message !== ''">
						<small :class="message_class" class="m-2" v-text="message"></small>
					</p>
				</div>
			</b-form-group>
		</b-collapse>
	</div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'SharedUserData',
	components: {
		vSelect,
	},
	props: {},
	data() {
		return {
			delete_icon: '',
			message: '',
			message_class: 'text-danger',
			members_sharing: null,
			share_members_selected: null,
			share_members: [],
			updateDisabled: true,
		};
	},
	mounted() {
		this.SharedMembersGet();
	},
	methods: {
		membersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.membersGet(loading, search, this);
			}
		},
		membersGet(loading, search) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'team_members');
			axios({
				url: _this.$store.state.api_url + 'teamMembersSearch',
				params: params,
			})
				.then(function (response) {
					_this.share_members = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: membersGet.');
				});
		},

		removeMember(item, obj) {
			if (confirm('Do you really want to disconnect?')) {
				let _this = this;
				obj.target.className = 'fas fa-spinner fa-spin text-secondary';
				let params = new URLSearchParams();
				params.append('token', this.$store.state.session_id);
				params.append('user_id', this.$store.state.profile.id);
				params.append('member_id', item.id);
				axios({
					url: _this.$store.state.api_url + 'SharedMembersRemove',
					params: params,
				})
					.then(function (response) {
						if (response.data.status == 1) {
							_this.members_sharing = _this.members_sharing.filter(function (obj) {
								return obj.id !== item.id;
							});
						}
					})
					.catch(function () {
						console.log('Error: SharedMembersRemove.');
					});
			}
		},

		SharedMembersGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('user_id', this.$store.state.profile.id);
			axios({
				url: _this.$store.state.api_url + 'SharedMembersGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.members_shared !== null) {
						_this.share_members_selected = Object.values(response.data.members_shared);
					}
					if (response.data.members_sharing !== null) {
						_this.members_sharing = Object.values(response.data.members_sharing);
					}
				})
				.catch(function () {
					console.log('Error: SharedMembersGet.');
				});
		},

		showMemberData(item) {
			this.$router.push('/dashboard/' + item.id);
		},

		updateSharedMembers() {
			let _this = this;

			_this.message = 'Processing';
			_this.message_class = 'text-danger';

			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('user_id', this.$store.state.profile.id);

			const membersS = Object.values(this.share_members_selected);
			for (const key of membersS) {
				params.append('share_members_selected[' + key.id + ']', this.$store.state.profile.id);
			}

			axios({
				url: _this.$store.state.api_url + 'SharedMembersUpdate',
				params: params,
			})
				.then(function (response) {
					_this.message = response.data.message;
					if (response.data.status == 1) {
						//_this.updateDisabled = true;
						_this.message_class = 'text-success';
					}
				})
				.catch(function () {
					console.log('Error: updateSharedMembers.');
				});
		},
	},
	computed: {},
	watch: {
		share_members_selected() {
			this.updateDisabled = false;
			this.message = '';
		},
	},
};
</script>

<style scoped>
#members_sharing .list-group-item {
	padding: 2px;
}
</style>
